import { Col, Form, Row, Table } from "antd";
import React, { useEffect, useState } from "react";
import Inputs from "../../biblio/Inputs/Inputs";
import SecondaryButton from "../../biblio/Buttons/SecondaryButton";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../apis/store";
import Selects from "../../biblio/Selects/Selects";
import PrimaryButton from "../../biblio/Buttons/PrimaryButton";
import { DeleteOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { showNotitfication } from "../utils/utils";
import {
  toAddProgramFamilyApplication,
  toGetProgramFamilyByProgramId,
} from "../../apis/actions/programs.actions";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import type { TableColumnsType } from "antd";
import {
  setResModel,
  setResIds,
  setRatingVisible,
} from "../../apis/slices/ratingSlice";

interface servicesRequestCardProps {
  program: any;
  setSelectedProgram: any;
}

const ProgramRequestCard = ({
  program,
  setSelectedProgram,
}: servicesRequestCardProps) => {
  const [form] = Form.useForm();
  const MySwal = withReactContent(Swal);
  const dispatch = useDispatch<AppDispatch>();
  const { data: programsBeneficiaries } = useSelector(
    (state: RootState) => state.programs.programsBeneficiaries
  );
  const [list, setList] = useState<any[]>([]);

  const toAddRequestBeneficiary = async () => {
    // Map through the list to extract beneficiary
    const mappedList = list.map((el) => ({
      beneficiary_id: el.beneficiary_id,
      mobile: el.mobile,
    }));

    // Validate each mobile field in the mapped list
    const errors = mappedList
      .map((el, index) => {
        // Check if the mobile number is missing
        if (!el.mobile || el.mobile.toString().trim().length !== 10) {
          return {
            name: `mobile${index}`,
            errors: ["الرجاء تعبئة الحقل"],
          };
        }
        return null;
      })
      .filter(Boolean);

    // If there are validation errors, update the form with error messages and stop the process
    if (errors.length > 0) {
      form.setFields(errors as any);
      return;
    }

    // Create the request payload
    const addRequest: any = {
      program_id: program.id,
      beneficiary_lines: mappedList,
    };

    try {
      const success = (await dispatch(
        toAddProgramFamilyApplication(addRequest)
      )) as any;
      const json = success?.payload?.data?.result;

      if (json?.code === 200) {
          dispatch(setResModel(json?.res_model));
      
          const resIds = [
              ...(json?.application_ids || []).map((item: any) => item.id).filter((id: any) => id != null),
              ...(json?.provisation_ids || []).map((item: any) => item.id).filter((id: any) => id != null),
          ];
      
          dispatch(setResIds(resIds.flat())); 
        const application_ids = json.application_ids.map((el: any) => el.name);
        const provision_application_ids = json.provision_application_ids.map(
          (el: any) => el.name
        );

        let listHtml = "";

        if (application_ids.length > 0) {
          listHtml = `<p>${
            json.application_ids[0].message
          }</p><ul dir="rtl" style="list-style-type:none">${application_ids
            .map((item: any) => `<li><b>${item}</b></li>`)
            .join("")}</ul>`;
        }

        if (provision_application_ids.length > 0) {
          listHtml += `<p>${
            json.provision_application_ids[0].message
          }</p><ul dir="rtl" style="list-style-type:none">${provision_application_ids
            .map((item: any) => `<li><b>${item}</b></li>`)
            .join("")}</ul>`;
        }

        MySwal.fire({
          html: listHtml,
          icon: "success",
          confirmButtonText: "تقييم الخدمة",
          showCloseButton: true,
          showConfirmButton: true,
          customClass: {
            popup: "takaful--swal-font",
            confirmButton: "takaful--grey-button takaful--grey-button-active", 
          },
        }).then((result) => {
          if (result.isConfirmed) {
            dispatch(setRatingVisible(true));
          }
        });
        setSelectedProgram(null);
      } else {
        showNotitfication(json.message, "error");
      }
    } catch (error) {
      console.error();
    }
  };

  useEffect(() => {
    const mappedList = list.map((el) => ({
      beneficiary_id: el.beneficiary_id,
      mobile: el.mobile,
    }));

    // Validate each mobile field in the mapped list
    const errors = mappedList
      .map((el, index) => {
        // Check if the mobile number is missing
        if (!el.mobile || el.mobile.toString().trim().length !== 10) {
          return {
            name: `mobile${index}`,
            errors: ["الرجاء تعبئة الحقل"],
          };
        } else {
          return {
            name: `mobile${index}`,
            errors: [],
          };
        }
      })
      .filter(Boolean);

    form.setFields(errors as any);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list]);

  useEffect(() => {
    dispatch(toGetProgramFamilyByProgramId({ program_id: program.id }));
  }, [dispatch, program]);

  useEffect(() => {
    if (programsBeneficiaries?.length > 0) {
      setList([
        {
          mobile: programsBeneficiaries[0].mobile,
          beneficiary_id: programsBeneficiaries[0].id,
        },
      ]);
    }
  }, [program, programsBeneficiaries, dispatch]);

  const handleInputChange = (e: any, index?: number) => {
    const inputValue = e.target.value;
    const updatedList = [...list];
    updatedList[index!!].mobile = inputValue;
    setList(updatedList);
  };

  const toAdd = () => {
    const nextBeneficiary = programsBeneficiaries.find(
      (beneficiary: any) =>
        !list.some((item) => item.beneficiary_id === beneficiary.id)
    );

    if (nextBeneficiary) {
      setList([
        ...list,
        {
          beneficiary_id: nextBeneficiary.id,
          mobile: nextBeneficiary.mobile,
        },
      ]);
    }
  };

  const toDelete = (index: number) => {
    setList(list.filter((_, i) => i !== index));
  };

  const getAvailableBeneficiaries = (index: number) => {
    return programsBeneficiaries.filter(
      (item1: any) =>
        !list
          .filter((_: any, i: number) => i !== index)
          .some((item2) => item2.beneficiary_id === item1.id)
    );
  };

  const onSelectChange = (e: any, index: number) => {
    if (!e) return;

    const selectedBeneficiary = programsBeneficiaries.find(
      (beneficiary: any) => beneficiary.id === e.value
    );

    if (selectedBeneficiary) {
      const updatedList = [...list];
      updatedList[index] = {
        ...updatedList[index],
        beneficiary_id: selectedBeneficiary.id,
        mobile: selectedBeneficiary.mobile,
      };
      setList(updatedList);
    }
  };
  const columns: TableColumnsType<any> = [
    {
      title: "المستفيد",
      dataIndex: "beneficiary_id",
      width: 200,
      render: (beneficiary_id: any, record: any, index: number) => (
        <Selects
          disabled={index < list?.length - 1}
          value={beneficiary_id}
          style={{
            width: "100%",
          }}
          popupMatchSelectWidth={220}
          options={
            programsBeneficiaries ? getAvailableBeneficiaries(index) : []
          }
          className="takaful--request-select"
          onChange={(e) => onSelectChange(e, index)}
          allowClear={false}
        />
      ),
    },
    {
      title: "الهاتف",
      dataIndex: "mobile",
      width: 200,
      render: (mobile: string, record: any, index: number) => (
        <Form.Item
          name={`mobile${index}`}
          rules={[
            {
              required: true,
              message: "الرجاء تعبئة الحقل",
            },
            {
              len: 10,
              message: "يجب أن يتكون رقم الهاتف من 10 ارقام",
            },
          ]}
        >
          <div style={{ paddingTop: "1.5rem" }}>
            <Inputs
              sizeInput="middle"
              type="tel"
              style={{
                height: "33px",
                padding: "1.2rem 0.5rem",
                fontSize: "1rem",
              }}
              placeholder="05XXXXXXXX"
              maxLength={10}
              value={mobile}
              onChange={(e) => handleInputChange(e, index)}
            />
          </div>
        </Form.Item>
      ),
    },
    {
      title: (
        <div className="takaful--table-service-button-container">
          <PrimaryButton
            title={""}
            disabled={list.length === programsBeneficiaries?.length}
            icon={<PlusCircleOutlined />}
            onClick={() => toAdd()}
          />
        </div>
      ),
      dataIndex: "id",
      width: 50,
      render: (id: number, record: any, index: number) => (
        <div className="takaful--table-service-button-container">
          {list?.length > 1 && (
            <PrimaryButton
              title={""}
              icon={<DeleteOutlined />}
              onClick={() => toDelete(index)}
            />
          )}
        </div>
      ),
    },
  ];

  return (
    <div dir="rtl">
      <Form
        form={form}
        layout="vertical"
        className="takaful--form-service-request"
      >
        <div className="takaful--table-container">
          <Table<any>
            style={{ direction: "rtl" }}
            columns={columns}
            className="takaful--table"
            scroll={{ x: "max-content" }}
            pagination={false}
            dataSource={list}
            locale={{
              emptyText: "لا يوجد بيانات ",
            }}
          />
        </div>
      </Form>
      <div className="takaful--services-request-button-container">
        <SecondaryButton
          title="الترشح للبرنامج"
          className="takaful--services-request-button"
          onClick={() => toAddRequestBeneficiary()}
        />
      </div>
      <Row dir="rtl" style={{ marginTop: "1rem" }}>
        <Col
          xxl={24}
          xl={24}
          lg={24}
          md={24}
          sm={24}
          xs={24}
          style={{ textAlign: "center" }}
        >
          <span className="takaful--services-request-span">
            سيتم مراعات الاولوية عند اعتماد الترشحات وفق
          </span>
          <p className="takaful--services-request-p">
            سياسة الخدمات في الجمعية
          </p>
        </Col>
      </Row>
    </div>
  );
};

export default ProgramRequestCard;
